import { render, staticRenderFns } from "./huishou_sum.vue?vue&type=template&id=24ddf39e&scoped=true&"
import script from "./huishou_sum.vue?vue&type=script&lang=js&"
export * from "./huishou_sum.vue?vue&type=script&lang=js&"
import style0 from "./huishou_sum.vue?vue&type=style&index=0&id=24ddf39e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ddf39e",
  null
  
)

export default component.exports